import WorkerPool from '../lib/worker/WorkerPool.js';

export default new WorkerPool('/worker/filterCount.worker.js', { type: 'module' });
